import { Box, SvgIcon, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';

const ICON_SIZE = 24;

const iconStyles = {
	color: palette.text.primary,
	width: ICON_SIZE,
	height: ICON_SIZE,
	flexShrink: 0,
};

const typographyStyles = {
	color: palette.text.primary,
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	flex: '1 1 auto',
	minWidth: 0,
};

const linkStyles = {
	color: palette.primary.main,
	cursor: 'pointer',
	whiteSpace: 'nowrap',
	flexShrink: 0,
	'&:hover': {
		textDecoration: 'underline',
	},
};

interface AIToolsLinkProps {
	onClick?: () => void;
	isClickable?: boolean;
}

const AIToolsLink: React.FC<AIToolsLinkProps> = ({ onClick, isClickable = false }) => {
	const { t } = useTranslation();
	const iconColor = isClickable ? palette.primary.main : palette.text.primary;
	const textStyles = isClickable ? linkStyles : typographyStyles;

	const content = (
		<>
			<SvgIcon
				component={getMuiIcon('aiTools')}
				sx={{ ...iconStyles, color: iconColor }}
				viewBox="0 0 24 24"
			/>
			<Typography variant="body2" sx={textStyles}>
				{t('KI Tools')}
			</Typography>
		</>
	);

	if (isClickable && onClick) {
		return (
			<Box
				onClick={onClick}
				sx={{
					display: 'flex',
					alignItems: 'center',
					cursor: 'pointer',
					flexShrink: 0,
					gap: spaces.xs,
				}}
			>
				{content}
			</Box>
		);
	}

	return <Box sx={{ display: 'flex', alignItems: 'center', gap: spaces.xs }}>{content}</Box>;
};

export default AIToolsLink;
